import { enableAIExtension } from '@hive/core/blocksuite/ai';
import { enableHiveExtension } from '@hive/core/blocksuite/extensions';
import {
  type SpecBuilder,
  SpecProvider,
} from '@blocksuite/hive/shared/utils';
import { type FrameworkProvider } from '@toeverything/infra';

export function enableEditorExtension(
  framework: FrameworkProvider,
  mode: 'edgeless' | 'page',
  enableAI: boolean
): SpecBuilder {
  const spec = SpecProvider._.getSpec(mode);
  enableHiveExtension(spec, framework);
  enableAIExtension(spec, framework, enableAI);

  return spec;
}
